











import Vue from 'vue';
import {Component, Emit, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
import Report from "@/models/report/Report";
import ReportUpdateDialogAdditionalInfosAdministration
	from "@/components/report/ReportUpdateDialogAdditionalInfosAdministration.vue";
import {Permissions} from "@/helpers/constants";

@Component({
	components: {
		ReportUpdateDialogAdditionalInfosAdministration,
		AsiCardDetailEntry,
		AsiCardDetail
	}
})
export default class ReportCardAdditionalInfosAdministration extends Vue {

	@Prop({type: Object, default: null})
	public report!: Report | null;

	private icons = Icon;
	private updateDialogOpen: boolean = false;

	private get canBeEdited(): boolean {
		return this.isOffice;
	}

	private get isOffice(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightOffice);
	}

	@Emit('reportChanged')
	public reportChanged(event: Event): Event {
		this.updateDialogOpen = false;
		return event;
	}

}
